import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
const SKELETON_ITEMS_COUNT = 8;
export const EVENT_LIST_CLASS_NAME = 'divide-border-100 flex flex-col divide-y';
export const EVENT_ITEM_CLASS_NAME = 'py-4 first:pt-0 last:pb-0';
export const EventSkeletonItem = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-8 shrink-0 rounded-md" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex h-5 items-center justify-between gap-2"><Skeleton className="h-4 w-[120px]" /><Skeleton className="h-3.5 w-[70px]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-5 items-center"><Skeleton className="h-4 w-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex gap-2">{t0}<div className="flex w-full flex-col gap-0.5">{t1}{t2}<div className="flex h-5 items-center"><Skeleton className="h-4 w-2/3" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const EventsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className={EVENT_LIST_CLASS_NAME}>{Array.from({
        length: SKELETON_ITEMS_COUNT
      }, _temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, index) {
  return <li key={index} className={EVENT_ITEM_CLASS_NAME}><EventSkeletonItem /></li>;
}